import { Component } from "../../../modules/Core/Component";
import templateDefault from "../../templates/default/widgets/appointment";
import Services from "../../Services/Services";

export default class Appointment extends Component {
  id = "appointment";
  template = templateDefault;

  default_fields = {
    name: "",
    email: "",
    phone: "",
    date: "",
    time: "",
    store: "",
    message: "",
  };

  stores = [
    { slug: "store-1", name: "ΚΗΦΙΣΙΑ", email: "info1@casadipatsi.gr" },
    { slug: "store-2", name: "ΑΛΙΜΟΣ", email: "info2@casadipatsi.gr" },
    {
      slug: "store-3",
      name: "ΑΓΙΑ ΠΑΡΑΣΚΕΥΗ",
      email: "info3@casadipatsi.gr",
    },
    {
      slug: "store-4",
      name: "STOCK HOUSE ΜΕΤΑΜΟΡΦΩΣΗ",
      email: "g.patsis@casadipatsi.gr",
      // email: "support@automatapp.com",
    },
    {
      slug: "store-6",
      name: "ΗΡΑΚΛΕΙΟ ΚΡΗΤΗΣ",
      email: "g.patsis@casadipatsi.gr",
    },
  ];

  onLoad(data) {
    super.onLoad(data);

    this.setData({
      "default.stores": this.stores,
      "default.fields": {
        ...this.default_fields,
      },
    });
  }

  sendRequest(e) {
    e.preventDefault();

    const error = {
      fields: {},
    };

    const { name, phone, store, date, time } = this.getData(
      "default.fields",
      {}
    );

    if (!name) {
      error.fields["name"] = this.ucfirst("required-field-helpertext");
    }
    // if (!email) {
    //   error.fields["email"] = this.ucfirst("email-helpertext");
    // } else {
    //   if (!this.getHelpers("validate").email(email)) {
    //     error.fields["email"] = this.ucfirst("invalid-email");
    //   }
    // }
    if (!phone) {
      error.fields["phone"] = this.ucfirst("required-field-helpertext");
    }
    if (!date) {
      error.fields["date"] = this.ucfirst("required-field-helpertext");
    }
    if (!time) {
      error.fields["time"] = this.ucfirst("required-field-helpertext");
    }
    if (!store) {
      error.fields["store"] = this.ucfirst("required-field-helpertext");
    }

    this.setData({
      error,
    });

    if (Object.keys(error.fields).length === 0) {
      const fields = {
        ...this.getData("default.fields", {
          ...this.default_fields,
        }),
      };

      fields["store"] = this.stores.find((st) => st.slug === store);

      Services.get("hook").then(async ([hookService]) => {
        await hookService.post("appointment", fields);

        this.setData({
          "default.fields": {
            ...this.default_fields,
          },
          error: {},
        });

        this.getComponents()
          .findById("main-message")
          .first()
          .setData({
            "message-duration": 1000,
            "success-message": this.trans("message-sent"),
          });
      });
    }
  }
}
